let pending = null;

export const setPendingFile = (f) => {
  pending = f;
};

export const takePendingFile = () => {
  const f = pending;
  pending = null;
  return f;
};
